import { useQuery } from '@tanstack/react-query';
import { getNotificationByRef } from '../services/notificationService';

/**
 * Resolve a `/n/<ref>` shortlink into the NotificationSummary.
 *
 * Disabled when ref is null/empty so the page can render an error state
 * without firing a request. `retry: false` because the failure modes here
 * (401 not authed, 403 wrong account, 404 unknown ref) aren't transient.
 */
export function useNotificationByRef(ref: string | null) {
  return useQuery({
    queryKey: ['notification-ref', ref],
    queryFn: () => getNotificationByRef(ref!),
    enabled: !!ref,
    retry: false,
  });
}
